import React from "react";
import {ASSET_TYPE, MODEL_KEYWORLD_LIST} from "components/Layout/constants";
import ImageTypeList from "../ImageTypeList";
import {useGetAssetsInfiniteQuery} from "hooks";
import styles from "./index.module.scss";

function ModelTab() {
  return (
    <div className={styles.container}>
      {MODEL_KEYWORLD_LIST.map((keyword, idx) => (
        <ListWrapperForQuery key={idx} keyword={keyword} />
      ))}
    </div>
  );
}

export default ModelTab;

function ListWrapperForQuery({keyword}) {
  const params = {
    publicStatus: true,
    topCategory: ASSET_TYPE.MODEL,
    keyword: keyword.name.toLowerCase(),
  };
  const {data, hasNextPage, fetchNextPage} = useGetAssetsInfiniteQuery(params);
  return (
    <ImageTypeList
      title={keyword.name}
      type={keyword.type}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      assetSearchParams={params}
      data={data}
    />
  );
}
